import { Link } from 'react-router-dom';
import { PasswordReset } from '@/components/PasswordReset';

const ForgotPassword = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-peach/30 to-primary/20 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <Link to="/">
            <img 
              src="/logo.png" 
              alt="Vivi con Amor y Arte" 
              className="h-20 w-auto mx-auto mb-4"
            />
          </Link>
        </div>

        <PasswordReset />

        <div className="text-center mt-6">
          <Link 
            to="/login" 
            className="text-sm text-primary hover:underline"
          >
            ← Volver al inicio de sesión
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;